import mattilsynet from './mattilsynet'
import snowchat from './snowchat'
import lab from './lab'
import rusinfo from './rusinfo'
import felleskatalogen from './felleskatalogen'
import diabetes from './diabetes'
import helsebiblioteket from './helsebiblioteket'
import sexogsamfunn from './sexogsamfunn'
import salubi from './salubi'

const configs = {
  mattilsynet,
  rusinfo,
  snowchat,
  lab,
  felleskatalogen,
  diabetes,
  helsebiblioteket,
  sexogsamfunn,
  salubi,
}

export default configs
